module.exports = __webpack_public_path__ + "img/nero 1.98d2299b.png";